import {
  Flex, Space, Switch, Typography
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import AddTime from "./addTime";
import TimeInput from "./timeInput";
import { AvailabilityDayProps } from "../../types/date";
import useAvailabilityDay from "./useAvailabilityDay";

const { Text } = Typography;

const AvailabilityDay = (props: AvailabilityDayProps) => {
  const { t } = useTranslation();
  const { item, values } = props;

  const {
    enabled,
    handleOnSwitch,
    loading
  } = useAvailabilityDay(props);

  return (
    <>
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Flex>
          <Text strong style={{ width: "50%" }}>{item.label}</Text>
          <Switch
            value={enabled}
            onClick={(checked) => handleOnSwitch(checked, values[item.name])}
            style={{ marginRight: "auto" }}
            disabled={loading}
            loading={loading}
          />
          <Text strong type="secondary">
            {enabled
              ? t("availabilityPage.availability.labelAvailable")
              : t("availabilityPage.availability.labelNotAvailable")}
          </Text>
        </Flex>
      </Space>
      {enabled ? (
        <Space direction="vertical" style={{ width: "100%", marginTop: 16 }}>
          <AddTime day={item.name}/>
          {values[item.name]?.list?.map((time: any) => (
            <TimeInput
              value={time.data.map(
                (hour: number) => dayjs().hour(hour)
              )}
              appointmentId={time.id}
              key={time.id}
            />
          ))}
        </Space>
      ) : null}
    </>
  );
};

export default AvailabilityDay;
